import React, { useState } from 'react';
import { ArrowRight, CheckCircle, Phone, Mail } from 'lucide-react';

const CTA: React.FC = () => {
  const [formData, setFormData] = useState({ name: '', email: '', company: '', fleetSize: '', phone: '' });
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitted(true);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const benefits = ['Free 14-day trial', 'No credit card required', 'Personalized onboarding', '24/7 phone and email support'];

  return (
    <section id="demo" className="py-20 bg-gradient-to-br from-primary-600 to-primary-800">
      <div className="container-main">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="text-white">
            <h2 className="text-h2 mb-6 font-heading">Ready to Transform Your Fleet Operations?</h2>
            <p className="text-body-lg text-white/90 mb-8">Join 500+ fleet operators who have reduced costs by 15-20% with GaadiMatic FleetX.</p>
            <div className="space-y-4 mb-8">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-center gap-3">
                  <CheckCircle className="w-5 h-5 text-accent-orange flex-shrink-0" />
                  <span className="text-white/90">{benefit}</span>
                </div>
              ))}
            </div>
            <div className="space-y-3">
              <div className="flex items-center gap-3 text-white/80">
                <Phone className="w-5 h-5" />
                <span>Call us: <a href="tel:+919916500454" className="text-white hover:underline">+91 99165 00454</a></span>
              </div>
              <div className="flex items-center gap-3 text-white/80">
                <Mail className="w-5 h-5" />
                <span>Email: <a href="mailto:info@gaadimatic.com" className="text-white hover:underline">info@gaadimatic.com</a></span>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
            {!isSubmitted ? (
              <>
                <h3 className="text-h4 text-navy-950 mb-2 font-heading">Request Your Personalized Demo</h3>
                <p className="text-gray-600 mb-6">Fill out the form below and our team will get in touch within 24 hours.</p>
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div className="grid sm:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Full Name *</label>
                      <input type="text" name="name" required value={formData.name} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-primary-500 outline-none transition-all" placeholder="John Doe" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Company Name *</label>
                      <input type="text" name="company" required value={formData.company} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-primary-500 outline-none transition-all" placeholder="ABC Logistics" />
                    </div>
                  </div>
                  <div className="grid sm:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Email Address *</label>
                      <input type="email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-primary-500 outline-none transition-all" placeholder="john@company.com" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number *</label>
                      <input type="tel" name="phone" required value={formData.phone} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-primary-500 outline-none transition-all" placeholder="+91 98765 43210" />
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Fleet Size *</label>
                    <select name="fleetSize" required value={formData.fleetSize} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-primary-500 outline-none transition-all bg-white">
                      <option value="">Select fleet size</option>
                      <option value="10-50">10-50 vehicles</option>
                      <option value="50-200">50-200 vehicles</option>
                      <option value="200-500">200-500 vehicles</option>
                      <option value="500+">500+ vehicles</option>
                    </select>
                  </div>
                  <button type="submit" className="w-full btn-primary mt-6">
                    Schedule My Demo
                    <ArrowRight className="ml-2 w-5 h-5" />
                  </button>
                  <p className="text-xs text-gray-500 text-center">By submitting, you agree to our privacy policy.</p>
                </form>
              </>
            ) : (
              <div className="text-center py-8">
                <div className="w-16 h-16 bg-accent-green/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <CheckCircle className="w-8 h-8 text-accent-green" />
                </div>
                <h3 className="text-h4 text-navy-950 mb-2 font-heading">Thank You!</h3>
                <p className="text-gray-600 mb-6">We have received your demo request. Our team will contact you within 24 hours.</p>
                <button onClick={() => setIsSubmitted(false)} className="text-primary-600 font-medium hover:underline">Submit another request</button>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
